import React from 'react';
import ReactDOM from 'react-dom/client';
import '@givebutter/primitives/fontawesome';
import { datadogRum } from '@datadog/browser-rum';
import App from 'App';
import 'index.css';

const commitSha =
  import.meta.env.VITE_GIT_COMMIT_SHA || import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA || '';

const requiredEnvVars = [
  import.meta.env.VITE_LIVEDISPLAY_DATADOG_CLIENT_TOKEN,
  import.meta.env.VITE_LIVEDISPLAY_DATADOG_APPLICATION_ID,
  import.meta.env.VITE_LIVEDISPLAY_DATADOG_ENV,
  commitSha,
];

const hasRequiredEnvVars = requiredEnvVars.every(v => !!v);

if (hasRequiredEnvVars) {
  datadogRum.init({
    clientToken: import.meta.env.VITE_LIVEDISPLAY_DATADOG_CLIENT_TOKEN,
    applicationId: import.meta.env.VITE_LIVEDISPLAY_DATADOG_APPLICATION_ID,
    site: 'datadoghq.com',
    service: 'livedisplay',
    env: import.meta.env.VITE_LIVEDISPLAY_DATADOG_ENV,
    version: commitSha.substring(0, 7),
    sessionSampleRate: 25,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [/^https:\/\/[^/]+\.givebutter\.com/, /^https:\/\/[^/]+\.legendairy\.xyz/],
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
